import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPolygonGeometry,
    PolygonGeometry,
    polygonGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import {
    VegetationType,
    vegetationTypeSchema,
} from 'app/agriculture/queries/entities/types/infrastructure/VegetationType';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface Vegetation extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;
    vegetationType: VegetationType;

    geometry: PolygonGeometry;
    pole: PointGeometry;
}

export const vegetationSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
    vegetationType: vegetationTypeSchema,

    geometry: polygonGeometrySchema,
    pole: pointGeometrySchema,
});

export const mockVegetation = ({
    id = '6d71a1ca-149e-4231-9e4f-c6f126f9afaa',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Vegetation Name',
    vegetationType = 'Forest',

    geometry = mockPolygonGeometry(),
    pole = mockPointGeometry(),
}: Partial<Vegetation> = {}): Vegetation => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,
    vegetationType,

    geometry,
    pole,
});
